export enum InboxModuleType {
    MESSAGING = "messaging",
    EMAIL = "email",
    TEAM = "team",
}
